import React from 'react';

const OnlineInterviewMenu = props => {
    return (
        <svg width='24' height='24' viewBox='0 0 24 24' {...props}>
            <path
                fill='#1D1D1B'
                fillRule='evenodd'
                d='M7.216 13.725c-.865 0-1.569-.703-1.569-1.568 0-.865.704-1.569 1.569-1.569s1.568.704 1.568 1.569-.703 1.568-1.568 1.568zm4.782 0c-.865 0-1.569-.703-1.569-1.568 0-.865.704-1.569 1.569-1.569s1.568.704 1.568 1.569-.703 1.568-1.568 1.568zm4.781 0c-.864 0-1.568-.703-1.568-1.568 0-.865.704-1.569 1.568-1.569.866 0 1.57.704 1.57 1.569s-.704 1.568-1.57 1.568z'
            />
        </svg>
    );
};

export default OnlineInterviewMenu;
